module.exports = __webpack_public_path__ + "static/16-863649bdfe09fb76e364c3636011ae9f.png";